/*
 * @Author: Jhonsem
 * @Date: 2018-10-25 20:33:27
 * @Last Modified by: Jhonsem
 * @Last Modified time: 2019-07-04 21:44:46
 */

import { ActionTree } from "vuex";
import * as types from "@/store/constants/types";
import Http from "@/api/http/fetch/index";
import { isIos } from "@/utils/lodash";
import generalUtilsHelper from "@/utils/generalUtils";
import LaunchUtils from "@/utils/launchUtils";
import EventBus from "@/utils/eventBus";
import { initialAnalytics } from "@/utils/analytics";
import * as appLifeCycle from "@/utils/appLifeCycle";
import checkinNotiHandler from "@/components/notification/CheckinNotiHandler";
import localStorageHelper from "@/localstorage/localstorage";
import getNoticeContent from "@/utils/killAppNotice.ts";
import { checkFreeFollowers, deliverFreeFollowers } from "@/api/http/gx/gxUser";
import http from "@/api/http/fetch";
import { sendEvent, sendEventWithParams } from "@/utils/analytics";
import { sendErrorEventToWindow } from "@/utils/analytics";
import handleNoticeRouterPush from "@/utils/handleNoticeRouterPush";
import {
  routerStackModule,
  routerInclude,
  routerIncludeTimes,
  routerIncludeVip,
  clearRouteStack
} from "@/utils/routerStackUtil";
import store from "@/store";
import SuperPayAndBackUpHelpers, {
  TEMP_KEY,
  LOCAL_KEY,
  RECORD_KEY
} from "@/utils/superPayAndBackUp";

// let superPayDialogShowed: boolean = false;
/**
 *  router push 首屏登录后的页面跳转逻辑
 */
const delayRouterPush = (Fn: any, time: any) => {
  setTimeout(() => {
    Fn();
  }, time);
};

/**
 * VIP跳转和弹窗的逻辑
 */
const vipActivityLogic = (dispatch: any, skipVipLogic: boolean = false) => {
  if (generalUtilsHelper.isVip() || skipVipLogic) {
    dispatch(types.SHOW_FREE_FOLLOWERS);
  } else {
    // 如果前面没显示vip 两种情况，一种，vipBeforeWelcome:false, 一种vipBeforeWelcome: true， 但是导量打开了, 并且初始化的时候已经拉到setting的导量参数
    if (
      !LaunchUtils.vipBeforeWelcome() ||
      (LaunchUtils.vipBeforeWelcome() &&
        store.getters[types.GETTER_IS_REDIRECT])
    ) {
      delayRouterPush(() => {
        //如果用户正在购买或者在Payment的页面，delay掉弹出页面：
        dispatch(types.ROUTER_PUSH, LaunchUtils.rootVipRoute("up"));
      }, 2500);
    } else {
      dispatch(types.SHOW_FREE_FOLLOWERS);
    }
  }
};

const routerPush = async (state: any, dispatch: any, getters: any) => {
  //先判断是否有导量的内容，并且判断是否配置了without_welcome为false，都满足就进导量
  if (
    getters[types.GETTER_HAS_REDIRECT] &&
    getters[types.GETTER_APP_TAKE_DOWN]
  ) {
    const dialogObj: any = {
      title: "New Version Available",
      midContent: `Dear users, we’ve released a new version, for more features and better user experience, please upgrade this app.`,
      buttons: [
        {
          text: "Upgrade Now",
          clickFn: async () => {
            const transferResult = await dispatch(
              types.TRANSFER_MASTER_ID_TO_IDFA
            );
            console.log(
              "getters[types.GETTER_HAS_REDIRECT].value",
              getters[types.GETTER_HAS_REDIRECT].value
            );
            Http.StartNewWebInstance(getters[types.GETTER_HAS_REDIRECT].value);
          },
          bgColor: "rgb(0,192, 188)"
        }
      ],
      closeImgShow: true,
      topIcon: require("@/assets/icons-file/dialog/picNewversionPopup@2x.png")
    };
    // 如果是强制导量则不允许删除，安全导量给入口跳走
    if (getters[types.GETTER_HAS_REDIRECT].name === "is_force_redirect") {
      dialogObj.closeImgShow = "hide";
    } else {
      dialogObj.buttons.push({
        text: "Not Now",
        clickFn: () => {
          vipActivityLogic(dispatch);
        }
      });
      dialogObj.backPressFn = () => vipActivityLogic(dispatch);
    }
    delayRouterPush(() => dispatch(types.DIALOG_SHOW, dialogObj), 500);
  } else if (
    getters[types.GETTER_APP_TAKE_DOWN] &&
    getters[types.GETTER_BACK_UP_APP_SHOW_ENABLE] &&
    getters[types.GETTER_BACK_UP_APP_SETTING_PARAMS_VALID] &&
    getters[types.GETTER_BACK_UP_APP_SETTING_PARAMS_VALID]
      .take_down_launch_enabled
  ) {
    dispatch(types.SHOW_REDIRECT_SUPER_PAY, "start1");
  } else {
    const superPayLaunchEnable = getters[
      types.GETTER_SUPER_PAY_PAY_LAUNCH_SHOW_ENABLE
    ]();

    if (superPayLaunchEnable) {
      const launchIndex = getters[types.GETTER_APP_LAUNCH_TIME];

      if (superPayLaunchEnable) {
        dispatch(types.ROUTER_PUSH, {
          name: "SuperPayLaunch",
          params: {
            routerTransition: "fadeIn"
          }
        });

        SuperPayAndBackUpHelpers.pushRecord(
          RECORD_KEY.LAUNCH_PAGE_SUPER_OR_BACK_OR_VIP_SHOW_RECORD,
          {
            name: "super_pay",
            index: launchIndex
          }
        );
        return;
      }
    } else {
      vipActivityLogic(dispatch);
    }
  }
};

const actions: ActionTree<any, any> = {
  async [types.INITIAL_ROUTE_TO_MAIN_TAB]({ dispatch }) {
    dispatch(types.ROUTER_REPLACE, LaunchUtils.rootMainRoute());
    dispatch(types.INITIAL_HANDLE_ROUTER);
  },

  /**
   * 执行路由跳转逻辑：如果不是空账号执行跳转
   */
  async [types.INITIAL_HANDLE_ROUTER]({
    state,
    commit,
    dispatch,
    rootState,
    getters
  }) {
    console.log("INITIAL_HANDLE_ROUTER:", new Date().valueOf());
    if (!generalUtilsHelper.isEmptyAccount()) {
      routerPush(rootState, dispatch, getters);
    } else {
      //如果是空账号，从其他类型的app去读取用户数据：
      Http.LoadUserInfo()
        .then((result: any) => {
          if (result && result.length > 0) {
            commit(types.ADD_OTHER_APP_USER, result);
          }
          routerPush(rootState, dispatch, getters);
        })
        .catch((error: any) => {});
    }
  },

  async [types.INITIAL_HANDLE_ROUTER_NOTICE](
    { state, commit, dispatch, rootState, getters },
    payload: any
  ) {
    handleNoticeRouterPush(payload);
  },

  /**
   * 版本号小于4.0.0的不支持ShowBatchNotification方法，app到前台也不会主动注销之前的通知
   */
  async [types.INITIAL_HANDLE_NOTICE]({
    state,
    commit,
    dispatch,
    rootState,
    getters
  }) {
    const appVersion = localStorageHelper.get("is_app_version_ok");
    if (!appVersion) {
      setTimeout(() => {
        checkinNotiHandler.configNotification();
      }, 8000);
    } else {
      setTimeout(() => {
        if (isIos()) {
          const data = getNoticeContent.calcNoticeData();
          const toNative = data.includes("&") ? data : data + "&";
          // Http.TerminateData(toNative);
        }
      }, 7000);
    }
  },

  /**
   * 1.拉取setting
   * 2.拉取feed流
   * 3.如果用户登录了需要拉取gx的user_info
   * 4.Android:需要初始化paypal的sdk
   */

  /**
   * 支付方式阈值的初始化
   */
  async [types.INITIAL_SETTING](
    { state, commit, dispatch, rootState, getters },
    payload: any
  ) {
    try {
      console.time("initial");
      //获取启动时间戳
      dispatch(types.INITIAL_TIME_STAMP);
      // 记录首次启动的时间戳
      commit(types.UPDATE_FIRST_USE_TIMESTAMP);

      appLifeCycle.initialListener();

      //拉取setting:
      await dispatch(types.REQUEST_GX_SETTING_DATA);
      appLifeCycle.initialGoBackListener();

      //支付方式阈值的初始化：
      dispatch(types.UPDATE_PAYMENT_SWITCH_THRESHOLD);
      //更新DeviceId:(异步拿取必须阻塞，避免后面拿不到device))
      await dispatch(types.UPDATE_DEVICE_ID);

      //Google analytics:
      initialAnalytics();

      const masterId = getters[types.GETTER_DEVICE_ID];
      dispatch(types.LOGIN_BY_GX, {
        masterId
      });

      //拉取feed:如果是安卓不提前拉取:
      if (isIos()) {
        dispatch(types.REQUEST_FEEDS);
      }

      // 更新订阅类型的列表
      dispatch(types.UPDATE_GX_SERVICE_LIST);
      dispatch(types.UPDATE_NATIVE_LOGIN_STATUS); //告诉原生materId和登陆状态，用来推送
      dispatch(types.INITIAL_HANDLE_NOTICE);

      if (!generalUtilsHelper.isEmptyAccount()) {
        //执行账号刷新 userinfo userMedia：
        const currentUserInfo = getters[types.GETTER_CURRENT_INS_USER_INFO];
        dispatch(types.UPDATE_USER_INS_INFO, {
          userId: currentUserInfo.userId,
          username: currentUserInfo.userName
        });

        // 如果存在用户，默认为老用户,不执行送followers的弹窗逻辑
        commit(types.UPDATE_FREE_FOLLOWERS_ENABLE_STATE);
      }

      if (payload && payload.notices && payload.notices.type) {
        dispatch(types.INITIAL_HANDLE_ROUTER_NOTICE, payload);
      }
    } catch (error) {
      console.log("INITIAL_SETTING Error:", error);
      sendErrorEventToWindow("INITIAL_SETTING_Error", error);
      return Promise.reject(error);
    }
  },

  // 展示doubleCoins或者halfCoins
  async [types.SHOW_SPECIAL_COINS]({ state, commit, dispatch, getters }) {
    if (
      generalUtilsHelper.isDoubleCoins() ||
      generalUtilsHelper.isHalfCoins()
    ) {
      if (generalUtilsHelper.isDoubleCoins()) {
        delayRouterPush(() => {
          dispatch(types.ROUTER_PUSH, {
            name: "DoubleCoinSplash",
            params: {
              routerTransition: "up"
            }
          });
          commit(types.UPDATE_DOUBLE_COIN_BUBBLE_STATUS, true);
        }, 500);
      } else if (generalUtilsHelper.isHalfCoins()) {
        delayRouterPush(() => {
          dispatch(types.ROUTER_PUSH, {
            name: "HalfCoinsSplash",
            params: {
              routerTransition: "up"
            }
          });
        }, 500);
      }
    } else {
      //如果没有coins活动:
      console.log("GETTER_CURRENT_OFFER", getters[types.GETTER_CURRENT_OFFER]);
      const showRecommendToast = () => {
        if (getters[types.GETTER_CURRENT_OFFER]) {
          EventBus.$emit(
            "recommend-offer-show",
            getters[types.GETTER_CURRENT_OFFER]
          );
        }
      };

      //是否开启下架模式:
      if (
        ((getters[types.GETTER_APP_TAKE_DOWN] &&
          getters[types.GETTER_SUPER_PAY_PARAMS] &&
          getters[types.GETTER_SUPER_PAY_PARAMS].take_down_launch_enabled) ||
          (getters[types.GETTER_APP_TAKE_DOWN] &&
            getters[types.GETTER_HAS_REDIRECT])) &&
        (!getters[types.GETTER_SUPER_PAY_APP_INSTALLED_STATUS] &&
          !getters[types.GETTER_BACK_UP_APP_INSTALLED_STATUS])
      ) {
      } else {
        showRecommendToast();
      }
    }
  },

  [types.SHOW_REDIRECT]({ state, commit, dispatch, getters }, payload: any) {
    const dialogObj: any = {
      title: "New Version Available",
      midContent: `Dear users, we’ve released a new version, for more features and better user experience, please upgrade this app.`,
      buttons: [
        {
          text: "Upgrade Now",
          clickFn: async () => {
            const transferResult = await dispatch(
              types.TRANSFER_MASTER_ID_TO_IDFA
            );
            console.log(
              "getters[types.GETTER_HAS_REDIRECT].value ==>",
              getters[types.GETTER_HAS_REDIRECT].value
            );
            Http.StartNewWebInstance(getters[types.GETTER_HAS_REDIRECT].value);
          },
          bgColor: "rgb(0,192, 188)"
        }
      ],
      closeImgShow: true,
      topIcon: require("@/assets/icons-file/dialog/picNewversionPopup@2x.png")
    };
    // 如果是强制导量则不允许删除，安全导量给入口跳走
    if (getters[types.GETTER_HAS_REDIRECT].name === "is_force_redirect") {
      dialogObj.closeImgShow = "hide";
    } else {
      dialogObj.buttons.push({
        text: "Not Now",
        clickFn: () => {}
      });
    }
    dispatch(types.DIALOG_SHOW, dialogObj);
  },

  // 新用户free followers逻辑
  [types.SHOW_FREE_FOLLOWERS]({ state, commit, dispatch, getters }) {
    const nativeFreeFollowersEnable =
      getters[types.GETTER_NATIVE_FREE_FOLLOWERS_ENABLE];
    const settingFreeFollowersEnable =
      getters[types.GETTER_SETTING_FREE_FOLLOWERS_ENABLE];

    // setting是否允许显示新用户加粉, 允许则进一步判断是否已登录
    if (settingFreeFollowersEnable && nativeFreeFollowersEnable) {
      // 如果当前不存在用户，则表示未登录，存在则已登录
      if (!generalUtilsHelper.isLoginUser()) {
        // 显示新用户加粉弹窗
        EventBus.$emit("show-free-followers-dialog");
        return;
      } else {
        dispatch(types.REQUEST_FREE_FOLLOWERS);
      }
    } else {
      // 直接进入coins弹窗逻辑
      dispatch(types.SHOW_SPECIAL_COINS);
    }
  },

  async [types.REQUEST_FREE_FOLLOWERS](
    { state, commit, dispatch, getters, rootState },
    payload: any
  ) {
    try {
      const masterId = getters[types.GETTER_MASTER_ID];
      const userId = getters[types.GETTER_CURRENT_INS_USER_ID];
      const nativeFreeFollowersEnable =
        getters[types.GETTER_NATIVE_FREE_FOLLOWERS_ENABLE];

      // 请求后台是否支持加粉弹窗 如果存在关闭的回调则需要弹请求的toast
      payload &&
        EventBus.$emit("toast-show", {
          type: "loading",
          content: "processing…",
          duration: "infinite"
        });
      const result: any = await checkFreeFollowers(masterId, userId.toString());
      console.log("checkFreeFollowers result: ", result);
      if (result && result.free_status === 1) {
        // 显示新用户加粉弹窗,带头像
        const userPic = getters[types.GETTER_CURRENT_INS_USER_INFO]
          ? getters[types.GETTER_CURRENT_INS_USER_INFO].userPic
          : "";

        // 如果本地还没弹出加粉弹窗， 则弹框， 如果已弹框，则根据返回值直接请求得粉接口或提示已领取过
        if (nativeFreeFollowersEnable) {
          EventBus.$emit("show-free-followers-dialog", userPic);
          EventBus.$emit("toast-hide");
        } else {
          // 直接领取
          const insInfo: any = getters[types.GETTER_CURRENT_INS_USER_INFO]
            ? getters[types.GETTER_CURRENT_INS_USER_INFO].insUserInfo
            : {};
          insInfo.user_id = userId.toString();
          const deliver_result: any = await deliverFreeFollowers(
            masterId,
            userId.toString(),
            insInfo
          );
          console.log("deliverFreeFollowers", deliver_result);
          EventBus.$emit("toast-hide");
          if (deliver_result) {
            payload && payload();
            EventBus.$emit("toast-show", {
              type: "success",
              content: `Congrats@${
                deliver_result.username
              }, 5 followers will arrive soon.`,
              duration: 3000
            });
            const pushData = {
              title: "😻5 Followers coming soon❗️",
              content: `@${
                deliver_result.username
              }, 5 free and real followers to you asap! ⏰🔥`,
              customData: { type: "orderCreateNotice" },
              timeInterval: 1000,
              badgeNumber: 0
            };
            http.ShowNotification(pushData);
            // const image =
            //   deliver_result.data && deliver_result.data.profile_pic_url;
            // const findOffer = {
            //   resource: {
            //     image_low: image
            //   },
            //   kind: "free_follow",
            //   effect: 5,
            //   type: "newbie_finished"
            // };
            // EventBus.$emit("show-delivered-dialog", findOffer);

            setTimeout(() => {
              dispatch(types.SHOW_SPECIAL_COINS);
            }, 3000);
          }
        }
      } else {
        if (nativeFreeFollowersEnable) {
          dispatch(types.SHOW_SPECIAL_COINS);
        } else {
          // 已经领取弹窗
          const midContent =
            "FREE followers are exclusive for newbies, please enjoy our other benefits. More bonus are waiting for you!";
          const topIcon = require("@/assets/icons-file/followers/pic_pop_sorry@3x.png");
          dispatch(types.DIALOG_SHOW, {
            title: "Sorry!",
            topIcon,
            midContent,
            buttons: [
              {
                text: "OK",
                clickFn: () => {
                  payload && payload();
                  dispatch(types.SHOW_SPECIAL_COINS);
                }
              }
            ]
          });
        }
      }
    } catch (error) {
      console.log("checkFreeFollowers error:", error);
      EventBus.$emit("toast-hide");

      // 如果是执行的是请求并加粉操作
      if (payload) {
        EventBus.$emit("toast-show", {
          type: "warning",
          content: "network failed",
          duration: 3000
        });
      } else {
        dispatch(types.SHOW_SPECIAL_COINS);
      }
      return Promise.reject(error);
    }
  },

  async [types.SHOW_REDIRECT_SUPER_PAY](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    const dialogObj: any = {
      title: "New Version Available",
      midContent: `Dear users, we’ve released a new version, for more features and better user experience, please upgrade this app.`,
      buttons: [
        {
          text: "Upgrade Now",
          clickFn: async () => {
            dispatch(types.START_INSTALL_BACK_UP_APP, {
              ga: "take_down_launch_popup"
            });
            sendEvent("uia_superapp_recommend_click", payload);
          },
          bgColor: "rgb(0,192, 188)"
        },
        {
          text: "Not Now",
          clickFn: () => {
            payload === "start1" && vipActivityLogic(dispatch);
          }
        }
      ],
      closeImgShow: true,
      topIcon: require("@/assets/icons-file/dialog/picNewversionPopup@2x.png")
    };
    delayRouterPush(() => dispatch(types.DIALOG_SHOW, dialogObj), 500);

    //打点：
    sendEventWithParams("uia_recommend_app_show", {
      back_up: "take_down_launch_popup"
    });
  },
  // 开机弹窗部分购买vip的跳转逻辑
  async [types.START_PURCHASE_VIP_BACK_PROCESS](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    const route = routerIncludeVip();
    if (
      route &&
      route.query &&
      route.query.type === "single" &&
      route.query.from === "root"
    ) {
      clearRouteStack();
      dispatch(types.ROUTER_PUSH, {
        name: "Followers",
        params: {
          routerTransition: "forward",
          comeFromNotice: false
        }
      });
      setTimeout(() => {
        dispatch(types.SHOW_FREE_FOLLOWERS);
      }, payload ? payload : 0);
      return Promise.resolve(true);
    } else {
      return Promise.resolve(false);
    }
  },
  async [types.UPDATE_LOCAL_FILES](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      const settingData = getters[types.GETTER_SETTING_DATA];
      if (settingData.local_files) {
        Http.SaveLocalFiles(settingData.local_files);
      }
    } catch (error) {
      console.log("UPDATE_LOCAL_FILES error:", error);
    }
  }
};

export default actions;
